// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input, TextField
} from "@mui/material";

// App Imports
import {changeProfile} from "./profileSlice";
import {addProfile, editProfile} from "./ProfileClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import FormDatePicker from "../../CommonComponents/FormDatePicker";


// Main Function
export default function ProfileDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorProfileId = useSelector((state) => state.profileSlc.value.id);
    const selectorProfileDrawerState = useSelector((state) => state.profileSlc.value.profileDrawerState);
    const selectorProfileDrawerMode = useSelector((state) => state.profileSlc.value.profileDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, control, reset, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my Profile data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorProfileDrawerMode==="Add"){
            addProfile(data)
                .then(() => {
                    console.log("Profile added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeProfile({
                    id: null, externalId: null, firstName: null, lastName: null,
                    ssn: null, dateOfBirth: null, dateOfDeath: null, companyName: null,
                    fein: null,dateOfDissolution:null,streetAddress:null,city:null,
                    stateProvince: null, postalCode: null, country: null, payStatus: null, status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    profileGridRefresh: true, profileDrawerState: false, profileDrawerMode: null}))
            })}
        if(selectorProfileDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addProfile(data)
                .then(() => {
                    console.log("Profile cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeProfile({id: null, externalId: null, firstName: null, lastName: null,
                    ssn: null, dateOfBirth: null, dateOfDeath: null, companyName: null,
                    fein: null,dateOfDissolution:null,streetAddress:null,city:null,
                    stateProvince: null, postalCode: null, country: null, payStatus: null, status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    profileGridRefresh: true, profileDrawerState: false, profileDrawerMode: null}))
            })}
        if(selectorProfileDrawerMode==="Edit"){
            console.log("This is the Profile Id I am going to edit")
            console.log(selectorProfileId)
            editProfile(selectorProfileId, data)
                .then(() => {
                    console.log("Profile edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeProfile({
                    profileGridRefresh: true, profileDrawerState: false, profileDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeProfileDrawer() {
        dispatchData(changeProfile({profileDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()
            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);


// *********************** END DROPDOWNS **************************


    const profile = useSelector((state) => state.profileSlc.value);

    useEffect(() => {

        reset({
            ...profile,
            dateOfBirth: profile.dateOfBirth
                ? dayjs(profile.dateOfBirth)
                : null,

            dateOfDeath: profile.dateOfDeath
                ? dayjs(profile.dateOfDeath)
                : null,

            dateOfDissolution: profile.dateOfDissolution
                ? dayjs(profile.dateOfDissolution)
                : null,

        });


    }, [profile, reset]);

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);

    // ****************** BEGIN FORM ****************************

    function profileForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 800, height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeProfileDrawer()}>Profile Form</h2>
                    <h4>{selectorProfileDrawerMode} Mode</h4>
                    {/*<br/>*/}
                    <br/>
                    <Input
                        style={{visibility: "hidden"}}
                        {...register('id', {required: false})}
                        id="id" name="id" label="id" aria-describedby="id_entry"
                        defaultValue={Number(useSelector((state) => state.profileSlc.value.id))}
                    />

                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('externalId', {required: true})}
                            id="externalId" name="externalId" label="External ID" aria-describedby="externalId_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.externalId)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('firstName', {required: false})}
                            id="firstName" name="firstName" label="First Name" aria-describedby="firstName_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.firstName)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('lastName', {required: false})}
                            id="lastName" name="lastName" label="Last Name" aria-describedby="lastName_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.lastName)}
                            sx={{width: 300}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('ssn', {required: false})}
                            id="ssn" name="ssn" label="SSN" aria-describedby="ssn_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.ssn)}
                            sx={{width: 200}}/>
                        {/*<TextField*/}
                        {/*    {...register('dateOfBirth', {required: false})}*/}
                        {/*    id="dateOfBirth" name="dateOfBirth" label="Date Of Birth"*/}
                        {/*    aria-describedby="dateOfBirth_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.profileSlc.value.dateOfBirth)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <FormDatePicker
                            name="dateOfBirth"
                            label="Date Of Birth"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                        {/*<TextField*/}
                        {/*    {...register('dateOfDeath', {required: false})}*/}
                        {/*    id="dateOfDeath" name="dateOfDeath" label="Date Of Death"*/}
                        {/*    aria-describedby="dateOfDeath_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.profileSlc.value.dateOfDeath)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <FormDatePicker
                            name="dateOfDeath"
                            label="Date Of Death"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('companyName', {required: false})}
                            id="companyName" name="companyName" label="Company Name"
                            aria-describedby="companyName_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.companyName)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('fein', {required: false})}
                            id="fein" name="fein" label="FEIN" aria-describedby="fein_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.fein)}
                            sx={{width: 200}}/>
                        {/*<TextField*/}
                        {/*    {...register('dateOfDissolution', {required: false})}*/}
                        {/*    id="dateOfDissolution" name="dateOfDissolution" label="Date Of Dissolution"*/}
                        {/*    aria-describedby="dateOfDissolution_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.profileSlc.value.dateOfDissolution)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <FormDatePicker
                            name="dateOfDissolution"
                            label="Date Of Dissolution"
                            control={control}
                            width={300}
                            variant = "outlined"
                        />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('streetAddress', {required: false})}
                            id="streetAddress" name="streetAddress" label="Street Address"
                            aria-describedby="streetAddress_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.streetAddress)}
                            sx={{width: 500}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('city', {required: false})}
                            id="city" name="city" label="City" aria-describedby="city_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.city)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('stateProvince', {required: false})}
                            id="stateProvince" name="stateProvince" label="State Province"
                            aria-describedby="stateProvince_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.stateProvince)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('postalCode', {required: false})}
                            id="postalCode" name="postalCode" label="Postal Code" aria-describedby="postalCode_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.postalCode)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('country', {required: false})}
                            id="country" name="country" label="Country" aria-describedby="country_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.country)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('paymentSystem', {required: false})}
                            id="paymentSystem" name="paymentSystem" label="Payment System" aria-describedby="paymentSystem_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.paymentSystem)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('payStatus', {required: false})}
                            id="payStatus" name="payStatus" label="Pay Status" aria-describedby="payStatus_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.payStatus)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('status', {required: false})}
                            id="status" name="status" label="Status" aria-describedby="status_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.status)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.profileSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeProfileDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>

            </div>
        )
    }

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorProfileDrawerState}
                onClose={closeProfileDrawer}
            >
                {profileForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
